"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.array.fill.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.typed-array.uint8-array.js");

require("core-js/modules/es.typed-array.copy-within.js");

require("core-js/modules/es.typed-array.every.js");

require("core-js/modules/es.typed-array.fill.js");

require("core-js/modules/es.typed-array.filter.js");

require("core-js/modules/es.typed-array.find.js");

require("core-js/modules/es.typed-array.find-index.js");

require("core-js/modules/es.typed-array.for-each.js");

require("core-js/modules/es.typed-array.includes.js");

require("core-js/modules/es.typed-array.index-of.js");

require("core-js/modules/es.typed-array.iterator.js");

require("core-js/modules/es.typed-array.join.js");

require("core-js/modules/es.typed-array.last-index-of.js");

require("core-js/modules/es.typed-array.map.js");

require("core-js/modules/es.typed-array.reduce.js");

require("core-js/modules/es.typed-array.reduce-right.js");

require("core-js/modules/es.typed-array.reverse.js");

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.slice.js");

require("core-js/modules/es.typed-array.some.js");

require("core-js/modules/es.typed-array.sort.js");

require("core-js/modules/es.typed-array.subarray.js");

require("core-js/modules/es.typed-array.to-locale-string.js");

require("core-js/modules/es.typed-array.to-string.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.typed-array.int32-array.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/web.url.js");

require("core-js/modules/web.url-search-params.js");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var wasm_bindgen;

(function () {
  var __exports = {};
  var wasm;
  var heap = new Array(32).fill(undefined);
  heap.push(undefined, null, true, false);

  function getObject(idx) {
    return heap[idx];
  }

  var heap_next = heap.length;

  function dropObject(idx) {
    if (idx < 36) return;
    heap[idx] = heap_next;
    heap_next = idx;
  }

  function takeObject(idx) {
    var ret = getObject(idx);
    dropObject(idx);
    return ret;
  }

  var cachedTextDecoder = new TextDecoder('utf-8', {
    ignoreBOM: true,
    fatal: true
  });
  cachedTextDecoder.decode();
  var cachegetUint8Memory0 = null;

  function getUint8Memory0() {
    if (cachegetUint8Memory0 === null || cachegetUint8Memory0.buffer !== wasm.memory.buffer) {
      cachegetUint8Memory0 = new Uint8Array(wasm.memory.buffer);
    }

    return cachegetUint8Memory0;
  }

  function getStringFromWasm0(ptr, len) {
    return cachedTextDecoder.decode(getUint8Memory0().subarray(ptr, ptr + len));
  }

  function makeMutClosure(arg0, arg1, dtor, f) {
    var state = {
      a: arg0,
      b: arg1,
      cnt: 1,
      dtor: dtor
    };

    var real = function real() {
      // First up with a closure we increment the internal reference
      // count. This ensures that the Rust closure environment won't
      // be deallocated while we're invoking it.
      state.cnt++;
      var a = state.a;
      state.a = 0;

      try {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return f.apply(void 0, [a, state.b].concat(args));
      } finally {
        if (--state.cnt === 0) {
          wasm.__wbindgen_export_0.get(state.dtor)(a, state.b);
        } else {
          state.a = a;
        }
      }
    };

    real.original = state;
    return real;
  }

  function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    var idx = heap_next;
    heap_next = heap[idx];
    heap[idx] = obj;
    return idx;
  }

  function __wbg_adapter_8(arg0, arg1, arg2) {
    wasm._dyn_core__ops__function__FnMut__A____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__hbcef8e440c0e4d5b(arg0, arg1, addHeapObject(arg2));
  }

  var WASM_VECTOR_LEN = 0;
  var cachedTextEncoder = new TextEncoder('utf-8');
  var encodeString = typeof cachedTextEncoder.encodeInto === 'function' ? function (arg, view) {
    return cachedTextEncoder.encodeInto(arg, view);
  } : function (arg, view) {
    var buf = cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
      read: arg.length,
      written: buf.length
    };
  };

  function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
      var buf = cachedTextEncoder.encode(arg);

      var _ptr = malloc(buf.length);

      getUint8Memory0().subarray(_ptr, _ptr + buf.length).set(buf);
      WASM_VECTOR_LEN = buf.length;
      return _ptr;
    }

    var len = arg.length;
    var ptr = malloc(len);
    var mem = getUint8Memory0();
    var offset = 0;

    for (; offset < len; offset++) {
      var code = arg.charCodeAt(offset);
      if (code > 0x7F) break;
      mem[ptr + offset] = code;
    }

    if (offset !== len) {
      if (offset !== 0) {
        arg = arg.slice(offset);
      }

      ptr = realloc(ptr, len, len = offset + arg.length * 3);
      var view = getUint8Memory0().subarray(ptr + offset, ptr + len);
      var ret = encodeString(arg, view);
      offset += ret.written;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
  }

  var cachegetInt32Memory0 = null;

  function getInt32Memory0() {
    if (cachegetInt32Memory0 === null || cachegetInt32Memory0.buffer !== wasm.memory.buffer) {
      cachegetInt32Memory0 = new Int32Array(wasm.memory.buffer);
    }

    return cachegetInt32Memory0;
  }

  function isLikeNone(x) {
    return x === undefined || x === null;
  }

  function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
      throw new Error("expected instance of ".concat(klass.name));
    }

    return instance.ptr;
  }
  /**
  * @param {Function} get_dgp
  * @param {Function} callback
  * @returns {StreamingHandle}
  */


  __exports.stream_block_number = function (get_dgp, callback) {
    var ret = wasm.stream_block_number(addHeapObject(get_dgp), addHeapObject(callback));
    return StreamingHandle.__wrap(ret);
  };

  function passArray8ToWasm0(arg, malloc) {
    var ptr = malloc(arg.length * 1);
    getUint8Memory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
  }

  function getArrayU8FromWasm0(ptr, len) {
    return getUint8Memory0().subarray(ptr / 1, ptr / 1 + len);
  }
  /**
  * @param {Uint8Array} key
  * @param {Uint8Array} iv
  * @param {Uint8Array} data
  * @returns {Uint8Array}
  */


  __exports.aes256_decrypt = function (key, iv, data) {
    try {
      var retptr = wasm.__wbindgen_add_to_stack_pointer(-16);

      var ptr0 = passArray8ToWasm0(key, wasm.__wbindgen_malloc);
      var len0 = WASM_VECTOR_LEN;
      var ptr1 = passArray8ToWasm0(iv, wasm.__wbindgen_malloc);
      var len1 = WASM_VECTOR_LEN;
      var ptr2 = passArray8ToWasm0(data, wasm.__wbindgen_malloc);
      var len2 = WASM_VECTOR_LEN;
      wasm.aes256_decrypt(retptr, ptr0, len0, ptr1, len1, ptr2, len2);
      var r0 = getInt32Memory0()[retptr / 4 + 0];
      var r1 = getInt32Memory0()[retptr / 4 + 1];
      var v3 = getArrayU8FromWasm0(r0, r1).slice();

      wasm.__wbindgen_free(r0, r1 * 1);

      return v3;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  };

  function handleError(f, args) {
    try {
      return f.apply(this, args);
    } catch (e) {
      wasm.__wbindgen_exn_store(addHeapObject(e));
    }
  }
  /**
  */


  var StreamingHandle = /*#__PURE__*/function () {
    function StreamingHandle() {
      _classCallCheck(this, StreamingHandle);
    }

    _createClass(StreamingHandle, [{
      key: "__destroy_into_raw",
      value: function __destroy_into_raw() {
        var ptr = this.ptr;
        this.ptr = 0;
        return ptr;
      }
    }, {
      key: "free",
      value: function free() {
        var ptr = this.__destroy_into_raw();

        wasm.__wbg_streaminghandle_free(ptr);
      }
    }], [{
      key: "__wrap",
      value: function __wrap(ptr) {
        var obj = Object.create(StreamingHandle.prototype);
        obj.ptr = ptr;
        return obj;
      }
    }]);

    return StreamingHandle;
  }();

  __exports.StreamingHandle = StreamingHandle;
  /**
  */

  var _Asset = /*#__PURE__*/function () {
    function _Asset() {
      _classCallCheck(this, _Asset);
    }

    _createClass(_Asset, [{
      key: "__destroy_into_raw",
      value: function __destroy_into_raw() {
        var ptr = this.ptr;
        this.ptr = 0;
        return ptr;
      }
    }, {
      key: "free",
      value: function free() {
        var ptr = this.__destroy_into_raw();

        wasm.__wbg__asset_free(ptr);
      }
      /**
      * @param {string} value
      * @returns {_Asset}
      */

    }, {
      key: "amount",
      get:
      /**
      * @returns {number}
      */
      function get() {
        var ret = wasm._asset_amount(this.ptr);

        return ret;
      }
      /**
      * @param {number} value
      */
      ,
      set: function set(value) {
        wasm._asset_set_amount(this.ptr, value);
      }
      /**
      * @returns {number}
      */

    }, {
      key: "amountFloat",
      get: function get() {
        var ret = wasm._asset_amountFloat(this.ptr);

        return ret;
      }
      /**
      * @param {number} value
      */
      ,
      set: function set(value) {
        wasm._asset_set_amountFloat(this.ptr, value);
      }
      /**
      * @returns {number}
      */

    }, {
      key: "precision",
      get: function get() {
        var ret = wasm._asset_precision(this.ptr);

        return ret >>> 0;
      }
      /**
      * @param {number} value
      */
      ,
      set: function set(value) {
        wasm._asset_set_precision(this.ptr, value);
      }
      /**
      * @returns {string}
      */

    }, {
      key: "symbol",
      get: function get() {
        try {
          var retptr = wasm.__wbindgen_add_to_stack_pointer(-16);

          wasm._asset_symbol(retptr, this.ptr);

          var r0 = getInt32Memory0()[retptr / 4 + 0];
          var r1 = getInt32Memory0()[retptr / 4 + 1];
          return getStringFromWasm0(r0, r1);
        } finally {
          wasm.__wbindgen_add_to_stack_pointer(16);

          wasm.__wbindgen_free(r0, r1);
        }
      }
      /**
      * @param {string} value
      */
      ,
      set: function set(value) {
        var ptr0 = passStringToWasm0(value, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;

        wasm._asset_set_symbol(this.ptr, ptr0, len0);
      }
      /**
      * @returns {boolean}
      */

    }, {
      key: "isUIA",
      value: function isUIA() {
        var ret = wasm._asset_isUIA(this.ptr);

        return ret !== 0;
      }
      /**
      * @param {number | undefined} _dec_places
      * @returns {string}
      */

    }, {
      key: "toString",
      value: function toString(_dec_places) {
        try {
          var retptr = wasm.__wbindgen_add_to_stack_pointer(-16);

          wasm._asset_toString(retptr, this.ptr, !isLikeNone(_dec_places), isLikeNone(_dec_places) ? 0 : _dec_places);

          var r0 = getInt32Memory0()[retptr / 4 + 0];
          var r1 = getInt32Memory0()[retptr / 4 + 1];
          return getStringFromWasm0(r0, r1);
        } finally {
          wasm.__wbindgen_add_to_stack_pointer(16);

          wasm.__wbindgen_free(r0, r1);
        }
      }
      /**
      * @param {number} num
      * @returns {_Asset}
      */

    }, {
      key: "_plus_num",
      value: function _plus_num(num) {
        var ret = wasm._asset__plus_num(this.ptr, num);

        return _Asset.__wrap(ret);
      }
      /**
      * @param {_Asset} a
      * @returns {_Asset}
      */

    }, {
      key: "_plus",
      value: function _plus(a) {
        _assertClass(a, _Asset);

        var ret = wasm._asset__plus(this.ptr, a.ptr);

        return _Asset.__wrap(ret);
      }
      /**
      * @param {number} num
      * @returns {_Asset}
      */

    }, {
      key: "_minus_num",
      value: function _minus_num(num) {
        var ret = wasm._asset__minus_num(this.ptr, num);

        return _Asset.__wrap(ret);
      }
      /**
      * @param {_Asset} a
      * @returns {_Asset}
      */

    }, {
      key: "_minus",
      value: function _minus(a) {
        _assertClass(a, _Asset);

        var ret = wasm._asset__minus(this.ptr, a.ptr);

        return _Asset.__wrap(ret);
      }
      /**
      * @param {number} num
      * @returns {_Asset}
      */

    }, {
      key: "_mul_num",
      value: function _mul_num(num) {
        var ret = wasm._asset__mul_num(this.ptr, num);

        return _Asset.__wrap(ret);
      }
      /**
      * @param {_Asset} a
      * @returns {_Asset}
      */

    }, {
      key: "_mul",
      value: function _mul(a) {
        _assertClass(a, _Asset);

        var ret = wasm._asset__mul(this.ptr, a.ptr);

        return _Asset.__wrap(ret);
      }
      /**
      * @param {number} num
      * @returns {_Asset}
      */

    }, {
      key: "_div_num",
      value: function _div_num(num) {
        var ret = wasm._asset__div_num(this.ptr, num);

        return _Asset.__wrap(ret);
      }
      /**
      * @param {_Asset} a
      * @returns {_Asset}
      */

    }, {
      key: "_div",
      value: function _div(a) {
        _assertClass(a, _Asset);

        var ret = wasm._asset__div(this.ptr, a.ptr);

        return _Asset.__wrap(ret);
      }
      /**
      * @param {_Asset} a
      * @returns {boolean}
      */

    }, {
      key: "eq",
      value: function eq(a) {
        _assertClass(a, _Asset);

        var ret = wasm._asset_eq(this.ptr, a.ptr);

        return ret !== 0;
      }
      /**
      * @param {_Asset} a
      * @returns {boolean}
      */

    }, {
      key: "ne",
      value: function ne(a) {
        _assertClass(a, _Asset);

        var ret = wasm._asset_ne(this.ptr, a.ptr);

        return ret !== 0;
      }
      /**
      * @param {_Asset} a
      * @returns {boolean}
      */

    }, {
      key: "lt",
      value: function lt(a) {
        _assertClass(a, _Asset);

        var ret = wasm._asset_lt(this.ptr, a.ptr);

        return ret !== 0;
      }
      /**
      * @param {_Asset} a
      * @returns {boolean}
      */

    }, {
      key: "lte",
      value: function lte(a) {
        _assertClass(a, _Asset);

        var ret = wasm._asset_lte(this.ptr, a.ptr);

        return ret !== 0;
      }
      /**
      * @param {_Asset} a
      * @returns {boolean}
      */

    }, {
      key: "gt",
      value: function gt(a) {
        _assertClass(a, _Asset);

        var ret = wasm._asset_gt(this.ptr, a.ptr);

        return ret !== 0;
      }
      /**
      * @param {_Asset} a
      * @returns {boolean}
      */

    }, {
      key: "gte",
      value: function gte(a) {
        _assertClass(a, _Asset);

        var ret = wasm._asset_gte(this.ptr, a.ptr);

        return ret !== 0;
      }
    }], [{
      key: "__wrap",
      value: function __wrap(ptr) {
        var obj = Object.create(_Asset.prototype);
        obj.ptr = ptr;
        return obj;
      }
    }, {
      key: "fromString",
      value: function fromString(value) {
        var ptr0 = passStringToWasm0(value, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;

        var ret = wasm._asset_fromString(ptr0, len0);

        return _Asset.__wrap(ret);
      }
      /**
      * @param {number} amount
      * @param {number} precision
      * @param {string} symbol
      * @returns {_Asset}
      */

    }, {
      key: "new",
      value: function _new(amount, precision, symbol) {
        var ptr0 = passStringToWasm0(symbol, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;

        var ret = wasm._asset_new(amount, precision, ptr0, len0);

        return _Asset.__wrap(ret);
      }
    }]);

    return _Asset;
  }();

  __exports._Asset = _Asset;

  function load(_x, _x2) {
    return _load.apply(this, arguments);
  }

  function _load() {
    _load = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(module, imports) {
      var bytes, instance;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof Response === 'function' && module instanceof Response)) {
                _context.next = 23;
                break;
              }

              if (!(typeof WebAssembly.instantiateStreaming === 'function')) {
                _context.next = 15;
                break;
              }

              _context.prev = 2;
              _context.next = 5;
              return WebAssembly.instantiateStreaming(module, imports);

            case 5:
              return _context.abrupt("return", _context.sent);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);

              if (!(module.headers.get('Content-Type') != 'application/wasm')) {
                _context.next = 14;
                break;
              }

              console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", _context.t0);
              _context.next = 15;
              break;

            case 14:
              throw _context.t0;

            case 15:
              _context.next = 17;
              return module.arrayBuffer();

            case 17:
              bytes = _context.sent;
              _context.next = 20;
              return WebAssembly.instantiate(bytes, imports);

            case 20:
              return _context.abrupt("return", _context.sent);

            case 23:
              _context.next = 25;
              return WebAssembly.instantiate(module, imports);

            case 25:
              instance = _context.sent;

              if (!(instance instanceof WebAssembly.Instance)) {
                _context.next = 30;
                break;
              }

              return _context.abrupt("return", {
                instance: instance,
                module: module
              });

            case 30:
              return _context.abrupt("return", instance);

            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 8]]);
    }));
    return _load.apply(this, arguments);
  }

  function init(_x3) {
    return _init.apply(this, arguments);
  }

  function _init() {
    _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(input) {
      var src, imports, _yield$load, instance, module;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (typeof input === 'undefined') {
                if (typeof document === 'undefined') {
                  src = location.href;
                } else {
                  src = document.currentScript.src;
                }

                input = src.replace(/\.js$/, '_bg.wasm');
              }

              imports = {};
              imports.wbg = {};

              imports.wbg.__wbindgen_object_drop_ref = function (arg0) {
                takeObject(arg0);
              };

              imports.wbg.__wbindgen_cb_drop = function (arg0) {
                var obj = takeObject(arg0).original;

                if (obj.cnt-- == 1) {
                  obj.a = 0;
                  return true;
                }

                var ret = false;
                return ret;
              };

              imports.wbg.__wbg_call_e91f71ddf1f45cff = function () {
                return handleError(function (arg0, arg1) {
                  var ret = getObject(arg0).call(getObject(arg1));
                  return addHeapObject(ret);
                }, arguments);
              };

              imports.wbg.__wbg_call_e3c72355d091d5d4 = function () {
                return handleError(function (arg0, arg1, arg2) {
                  var ret = getObject(arg0).call(getObject(arg1), getObject(arg2));
                  return addHeapObject(ret);
                }, arguments);
              };

              imports.wbg.__wbg_instanceof_Promise_0fb5d7e26ca83626 = function (arg0) {
                var ret = getObject(arg0) instanceof Promise;
                return ret;
              };

              imports.wbg.__wbg_then_6d5072fec3fdb237 = function (arg0, arg1) {
                var ret = getObject(arg0).then(getObject(arg1));
                return addHeapObject(ret);
              };

              imports.wbg.__wbindgen_throw = function (arg0, arg1) {
                throw new Error(getStringFromWasm0(arg0, arg1));
              };

              imports.wbg.__wbindgen_closure_wrapper77 = function (arg0, arg1, arg2) {
                var ret = makeMutClosure(arg0, arg1, 18, __wbg_adapter_8);
                return addHeapObject(ret);
              };

              if (typeof input === 'string' || typeof Request === 'function' && input instanceof Request || typeof URL === 'function' && input instanceof URL) {
                input = fetch(input);
              }

              _context2.t0 = load;
              _context2.next = 15;
              return input;

            case 15:
              _context2.t1 = _context2.sent;
              _context2.t2 = imports;
              _context2.next = 19;
              return (0, _context2.t0)(_context2.t1, _context2.t2);

            case 19:
              _yield$load = _context2.sent;
              instance = _yield$load.instance;
              module = _yield$load.module;
              wasm = instance.exports;
              init.__wbindgen_wasm_module = module;
              return _context2.abrupt("return", wasm);

            case 25:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _init.apply(this, arguments);
  }

  wasm_bindgen = Object.assign(init, __exports);
})();

var _default = wasm_bindgen;
exports.default = _default;